/**
 * 檔案用途區塊
 * @module ContentLayout
 * @purpose 提供共用內容容器元件，統一包裹子節點並支援測試識別屬性。
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
import React from 'react';
import { IBaseComponentProp } from '@shared/interfaces/base-component.interface';

type Props = IBaseComponentProp;

/**
 * 宣告內容用途說明與單號關聯
 * @description ContentLayout 函式元件。
 * @purpose 接收 testId 與 children，輸出包含 data-testid 的外層容器。
 * @external https://innotech.atlassian.net/browse/IN-46601
 */
const ContentLayout = ({ testId, children }: Props) => {
  return <div data-testid={testId}>{children}</div>;
};

export default ContentLayout;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:20:46.735Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/module, declaration block, bottom/llm record), mapped declaration external ticket to IN-46601 using full Jira URL, and kept runtime logic unchanged.
 */
